/**
 * Team mark colours, from the theme tokens (lib/themeVars.ts, global.css):
 * your team's mark is blood, every other team's olive-up, and a team that is
 * out has its box outlined in olive at 35%. One place, so the drawer and the
 * lobby draw the same marks.
 */
type Theme = 'light' | 'dark'

/** RGB triples of the tokens the team marks use, per theme. */
const TOKENS = {
  olive: { light: [74, 90, 42], dark: [138, 161, 74] },
  'olive-up': { light: [107, 126, 62], dark: [179, 204, 102] },
  blood: { light: [160, 24, 24], dark: [224, 70, 63] },
} as const

const hex = (rgb: readonly number[]) => `#${rgb.map((v) => v.toString(16).padStart(2, '0')).join('')}`

/** A team's mark colour: blood for the viewer's team, olive-up for the others. */
export function teamMarkColor(theme: Theme, isYours: boolean): string {
  return hex(TOKENS[isYours ? 'blood' : 'olive-up'][theme])
}

/** The outline of a team that is out: the olive token at 35%. */
export function eliminatedTeamBorder(theme: Theme): string {
  return `rgba(${TOKENS.olive[theme].join(',')},0.35)`
}
